import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {timezoneOf, toDate} from '../util/date-util';
import {DatePipe, formatDate} from '@angular/common';
import {PeriodDto, UserDto} from '@api/utisha-backend';
import LanguageEnum = UserDto.LanguageEnum;

@Pipe({ name: 'language' })
export class LanguagePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {
  }

  transform(value: LanguageEnum, format?: string): string {
    switch (value) {
      case LanguageEnum.En: return 'English';
      case LanguageEnum.Zh: return '中文';
    }
    return '';
  }
}
